module.exports = __webpack_public_path__ + "static/media/external-link-square.7e2db9f5.svg";